// 日志库封装
// 可根据平台将日志写到文件里或者上报给后台
// 也可以将console的方法重写

import time from '../time';

function timePrefix(): string {
    return time.formatTime(time.now());
}

const TRACE: number = 0; // 跟踪日志级别
const DEBUG: number = 1; // 调试日志级别
const INFO: number = 2; // 正常日志级别 上线基本上用这个
const WARN: number = 3; // 告警日志级别
const ERROR: number = 4; // 错误日志级别

let currentLevel: number = TRACE;

const console_trace = console.trace;
const console_debug = console.debug;
const console_log = console.log;
const console_info = console.info;
const console_warn = console.warn;
const console_error = console.error;

const currentMetrics: Metrics = {
    traceCnt: 0,
    debugCnt: 0,
    logCnt: 0,
    infoCnt: 0,
    warnCnt: 0,
    errorCnt: 0,
};

type Metrics = {
    traceCnt: number;
    debugCnt: number;
    logCnt: number;
    infoCnt: number;
    warnCnt: number;
    errorCnt: number;
};

function metrics(): Metrics {
    return Object.assign({}, currentMetrics);
}

function trace(...data: any[]): void {
    currentMetrics.traceCnt++;
    // if (currentLevel > TRACE) {
    //     return;
    // }
    console_trace(timePrefix(), 'TRACE', ...data);
}

function debug(...data: any[]): void {
    currentMetrics.debugCnt++;
    if (currentLevel > DEBUG) {
        return;
    }
    console_debug(timePrefix(), 'DEBUG', ...data);
}

function info(...data: any[]): void {
    currentMetrics.infoCnt++;
    if (currentLevel > INFO) {
        return;
    }
    console_info(timePrefix(), 'INFO', ...data);
}

function warn(...data: any[]): void {
    currentMetrics.warnCnt++;
    if (currentLevel > WARN) {
        return;
    }
    console_warn(timePrefix(), 'WARN', ...data);
}

function error(...data: any[]): void {
    currentMetrics.errorCnt++;
    if (currentLevel > ERROR) {
        return;
    }
    console_error(timePrefix(), 'ERROR', ...data);
    // todo 上报后台
}

// 不管日志级别，直接输出
function out(...data: any[]): void {
    console_log(timePrefix(), 'OUTPUT', ...data);
}

// 设置当前日志级别
function setLevel(level: number) {
    currentLevel = level;
}

// 获取当前日志级别
function getLevel(): number {
    return currentLevel;
}

function warp_console() {
    console.trace = (function (logFunc) {
        return function () {
            if (getLevel() <= TRACE) {
                // @ts-ignore
                logFunc.apply(console, arguments);
            }
        };
    })(console.trace);

    console.debug = (function (logFunc) {
        return function () {
            if (getLevel() <= DEBUG) {
                // @ts-ignore
                logFunc.apply(console, arguments);
            }
        };
    })(console.debug);

    console.log = (function (logFunc) {
        return function () {
            if (getLevel() <= INFO) {
                // @ts-ignore
                logFunc.apply(console, arguments);
            }
        };
    })(console.log);

    console.info = (function (logFunc) {
        return function () {
            if (getLevel() <= INFO) {
                // @ts-ignore
                logFunc.apply(console, arguments);
            }
        };
    })(console.info);

    console.warn = (function (logFunc) {
        return function () {
            if (getLevel() <= WARN) {
                // @ts-ignore
                logFunc.apply(console, arguments);
            }
        };
    })(console.warn);

    console.error = (function (logFunc) {
        return function () {
            if (getLevel() <= ERROR) {
                // @ts-ignore
                logFunc.apply(console, arguments);
            }
        };
    })(console.error);
}

const log = {
    TRACE,
    DEBUG,
    INFO,
    WARN,
    ERROR, // 日志级别定义
    getLevel,
    setLevel,
    trace,
    debug,
    info,
    warn,
    error,
    out,
    metrics,
    warp_console, // 包装console方法
};

export default log;
